<template lang="pug">
.erase-customer-data
    el-dialog(
        title="Excluir dados do cliente",
        :visible="visible"
        @update:visible="updateVisible($event)",
        width="50%"
    )

        p Tem certeza de que deseja excluir os dados deste cliente? Esta ação é irreversível.

        el-form(ref="form", :rules="rules", :model="data")
            el-form-item(label="Confirmação de e-mail", prop="emailConfirmation")
                el-input(v-model="data.emailConfirmation", placeholder="Digite o e-mail do cliente")

        span(slot="footer", style="display: flex; flex-direction: row; gap: 10px; justify-content: flex-end;")
            el-button(@click="updateVisible(false)") Cancelar

            el-popconfirm(title="Realmente tem certeza de que deseja excluir dados deste cliente?", @confirm="erase")
                el-button(type="danger", slot="reference", :loading="erasing") Excluir dados

</template>
<script setup>
import { ref, watch } from 'vue'
import { useMessage } from '@/utils/Message'

import CustomerService from '@/services/CustomerService'

const message = useMessage()

const props = defineProps({
  customerId: {
    type: Number,
    required: true
  },
  customerEmail: {
    type: String,
    required: true
  },
  visible: {
    type: Boolean,
    required: true
  }
})

const emit = defineEmits(['update:visible', 'executed'])

const form = ref()
const erasing = ref(false)

const data = ref({
  emailConfirmation: ''
})

const rules = ref({
  emailConfirmation: [
    { required: true, message: 'Por favor, confirme o e-mail do cliente', trigger: 'blur' },
    { validator: (rule, value, callback) => {
      if (value === props.customerEmail) {
        callback()
      } else {
        callback(new Error('O e-mail não confere com o e-mail cadastrado'))
      }
    }, message: 'O e-mail não confere com o e-mail cadastrado', trigger: 'blur' }
  ]
})

const updateVisible = (value) => {
  emit('update:visible', value)
}

const erase = async () => {
  try {
    await form.value.validate()
  } catch (error) {
    message.error('Por favor, confirme o e-mail do cliente')

    return Promise.reject(error)
  }

  erasing.value = true

  try {

    await CustomerService.eraseCustomerData(props.customerId)

    message.success('Dados do cliente excluídos com sucesso.')

    emit('update:visible', false)
    emit('executed')
  } catch (error) {
    message.error('Erro ao excluir dados do cliente.')
  } finally {
    erasing.value = false
  }
}

watch(() => props.visible, (newValue) => {
  if (newValue) {
    data.value.emailConfirmation = ''
  }
})
</script>
